import React, { useContext, useEffect } from "react";
import { MapContext } from "../../context/map.context";
import { useCategory, useCategoryPois } from "../../data/mazemap.api";
//@ts-ignore
import Mazemap from "@itpi/mazemap";
import { Link, useNavigate } from "react-router-dom";
import BottomSheetWrapper from "../BottomSheetWrapper";
import {
  Alert,
  AlertIcon,
  Box,
  Center,
  CloseButton,
  Flex,
  Heading,
  Icon,
  Image,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { MdCategory } from "react-icons/md";
import BackButton from "../BackButton";

type Props = {
  id: string;
};

const CategorySearchResult = ({ id }: Props) => {
  const { data, isLoading, isError } = useCategory(parseInt(id));
  const {
    data: pois,
    isLoading: poisLoading,
    isError: poisError,
  } = useCategoryPois(parseInt(id));
  const { map, reset, setPins, fitBounds } = useContext(MapContext);

  const navigate = useNavigate();

  useEffect(() => {
    if (pois) {
      const bounds = Mazemap.Util.Turf.bbox(pois);
      fitBounds(bounds, {
        padding: { left: 50, right: 50, top: 200, bottom: 200 },
      });

      const points = pois.features.map((poi) => {
        const center = Mazemap.Util.Turf.center(poi.geometry);
        const [lng, lat] = center.geometry.coordinates;
        return {
          lat,
          lng,
          onClick: () => navigate(`/location/poi/${poi.properties?.poiId}`),
          zLevel: poi.properties?.zLevel,
        };
      });
      setPins(points);
      return reset;
    }
  }, [pois, setPins, reset, map, navigate]);

  return (
    <BottomSheetWrapper>
      {isLoading || poisLoading ? (
        <Center p={8}>
          <Spinner />
        </Center>
      ) : isError || poisError ? (
        <Center p={8}>
          <Alert status="error">
            <AlertIcon />
            Could not find a category with ID "{id}".
          </Alert>
        </Center>
      ) : data && pois ? (
        <Box position="relative" p={5}>
          <BackButton />
          <Flex gap={4} alignItems="center">
            {data.icon ? (
              <Image src={data.icon} h={14} />
            ) : (
              <Icon as={MdCategory} h={12} w={12} opacity={0.7} />
            )}
            <Box>
              <Heading size="md">{data.title}</Heading>
              <Text opacity={0.7}>{pois.features.length} places</Text>
            </Box>
          </Flex>
        </Box>
      ) : null}
    </BottomSheetWrapper>
  );
};

export default CategorySearchResult;
